import {styled} from "@mui/material";

export const TitleContainer = styled("div")(() => ({
    width: '100%',
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    justifyContent: "space-between",
    gap: '1rem'
}));

export const BankCardsContainer = styled('div')(() => {
    return {
        width: '100%',
        padding: '0.5rem',
        overflow: 'auto',
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '0.5rem',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    }
});

export const NoPaymentMethodContainer = styled('div')(() => {
    return {
        width: '100%',
        padding: '0.5rem',
        overflow: 'auto',
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '0.5rem',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
});

export const CreditCardContainer = styled('div')(({theme}) => {
    return {
        padding: '2px',
        '& .rccs__card--front': {
            boxShadow: 'none'
        }
    }
});

export const HoveredCreditCardContainer = styled(CreditCardContainer)(({theme}) => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
});

export const CreditCardOverlay = styled('div')(({theme}) => {
    return {
        position: 'absolute',
        zIndex: 1,
        background: '#2A2E3C50',
        width: '18rem',
        height: '11.5rem',
        borderRadius: '1rem'
    }
});

export const CreditCardRemoveIconContainer = styled('div')(({theme}) => {
    return {
        width: '1.8rem',
        height: '1.8rem',
        position: 'absolute',
        zIndex: 2,
        backgroundColor: '#FFF',
        borderRadius: '0.15rem',
        padding: '0.37rem',
        cursor: 'pointer',
    }
});

export const SelectedCardContainer = styled('div')(({theme}) => {
    return {
        padding: 'unset',
        border: `2px solid ${theme.barekam.lightGreen}`,
        borderRadius: '17px',
        boxShadow: '0px 3px 6px 0px rgba(69, 77, 102, 0.50)'
    }
});
